import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { AllventuresList } from "./vendors-list";

export const AllVendors = () => {
	const { height, width } = useWindowDimensions();
	return (
		<>
			{width && width < 720 ? (
				//  Start - Mobile View
				<AllventuresList />
				//  End - Mobile View  
			) : width && width >= 720 && width < 1024 ? (
				//  Start - Tablet View
				<AllventuresList />
				//  End - Tablet View
			) : (
				//  Start - Web View  
				<AllventuresList />
				//  End - Web View  
			)}
		</>
	)
}